import { Marquee } from "@/components/primitives";
import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";
import HiddenCost from "@/components/sections/HiddenCost";
import CapabilitiesSection from "@/components/sections/CapabilitiesSection";
import ApproachTimeline from "@/components/sections/ApproachTimeline";
import WhyUs from "@/components/sections/WhyUs";
import ImagineTomorrow from "@/components/sections/ImagineTomorrow";
import IndustriesSection from "@/components/sections/IndustriesSection";
import AssessmentCTA from "@/components/sections/AssessmentCTA";

const MARQUEE = [
    "Eliminating manual operations",
    "Practical AI automation",
    "Enterprise precision",
    "Built for shipping & logistics",
    "Less administration",
];

export default function Home() {
    return (
        <>
            <Hero />
            <Marquee items={MARQUEE} />
            <Stats />
            <HiddenCost />
            <CapabilitiesSection />
            <ApproachTimeline />
            <WhyUs />
            <ImagineTomorrow />
            <IndustriesSection />
            <AssessmentCTA />
        </>
    );
}
